<template>
	<CustomSelect
		:invalid="termInvalid"
		errorMsg="Please enter a valid term"
		v-model="value.academicTerm"
		:options="terms"
		label="Term"
		@change="updateTerm"
	>
	</CustomSelect>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from 'vuex';
import { CourseEntry } from '@/models';
import CustomSelect from '@/components/CustomSelect.vue';
import config from '@/models/services/config';

@Component({
	methods: mapMutations('wmct', {
		updateCourseTerm: 'UPDATE_COURSE_TERM',
	}),
	components: {
		CustomSelect,
	},
})
export default class TermSelector extends Vue {
	@Prop() public value!: CourseEntry;

	private terms = [
		{
			label: 'Spring',
			value: 1,
		},
		{
			label: 'Summer',
			value: 2,
		},
		{
			label: 'Fall',
			value: 3,
		},
		{
			label: 'Winter',
			value: 4,
		},
	];

	private get dark() {
		return config.Dark;
	}

	private updateCourseTerm!: ({ course, term }: { course: CourseEntry, term: number | null }) => void;

	private get termInvalid(): boolean {
		const isValidating = this.value.isValidating;
		const isValid =
			this.value.academicTerm != null
			&& (this.value.academicTerm as any) !== ''
			&& this.value.academicTerm > 0
			&& this.value.academicTerm <= 4;

		return isValidating && !isValid;
	}

	public updateTerm(term: number | null) {
		this.updateCourseTerm({ course: this.value, term });
	}
}
</script>
